import Skeleton from '@srm/ui/skeleton';
import Button from '@srm/ui/button';
import SearchResultSkeleton from '@organisms/Search/SearchResultItems/SearchResultSkeleton';
import type { SearchMode } from '@models/search/search.types';
import SearchQueryHeader from '../parts/SearchQueryHeader';
import '../GlobalSearchPage.scss';
import './GlobalSearchSkeleton.scss';

interface IGlobalSearchSkeletonProps {
    text?: string;
    mode?: SearchMode;
    onInterrupt?: () => void;
}

const GlobalSearchSkeleton = ({ text = '', mode = 'exact', onInterrupt }: IGlobalSearchSkeletonProps) => (
    <div className="gsearch gsearch-skeleton" role="status" aria-label="Загрузка поиска" aria-busy="true">
        <div inert>
            <SearchQueryHeader text={text} mode={mode} onEditQuery={() => {}} />
        </div>
        <div className="gsearch__scopes" aria-hidden>
            <div className="gsearch__scope-list">
                {[78, 88, 98].map((width) => (
                    <div className="gsearch__scope-skeleton" key={width}>
                        <Skeleton height={14} width={width} radius="sm" />
                    </div>
                ))}
            </div>
        </div>
        <div className="gsearch__workspace">
            <div className="gsearch__results">
                <div className="gsearch__toolbar" aria-hidden>
                    <Skeleton height={14} width={120} radius={5} />
                    <span className="gsearch__toolbar-spacer" />
                    <Skeleton height={32} width={200} radius={8} />
                </div>
                <div className="gsearch__pane">
                    {mode === 'ai' && (
                        <div className="gsearch__ai-progress">
                            <span>AI подбирает документы по смыслу — это может занять до минуты</span>
                            <Button variant="text" size="sm" disabled={!onInterrupt} onClick={onInterrupt}>
                                Отменить
                            </Button>
                        </div>
                    )}
                    <div className="gsearch__list">
                        <SearchResultSkeleton />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default GlobalSearchSkeleton;
